import React, { ComponentProps, ElementType, PropsWithChildren } from 'react'

import { classNames } from '@app/lib/bem'

export const createLayoutComponent = <T extends ElementType, E>(
  ComponentType: T,
  layoutClassName?: string,
  elements?: E
): React.FC<ComponentProps<T>> & E => {
  const component = (props: PropsWithChildren<ComponentProps<T>>) => {
    const { children, className, ...rest } = props

    return (
      <ComponentType className={classNames(className, layoutClassName)} {...(rest as any)}>
        {children}
      </ComponentType>
    )
  }

  return Object.assign(component, elements)
}
